import diserboImage from "@/assets/a4e461a348862c41ec6f5bfdb3e584781f3469b6.png";
import volatiliImage from "@/assets/c73f7d816f90636525995152ac3d0858347b4219.png";
import sanificazioneImage from "@/assets/3755d1bee00b88a37aec035def84d3852d3192b7.png";
import { Leaf, Bird, Droplets, Shield } from "lucide-react";

export const OTHER_SERVICES_PAGE = {
  HEADER: {
    TITLE: "Altri Servizi Specializzati",
    SUBTITLE:
      "Soluzioni avanzate e innovative per ogni esigenza specifica. Scopri i nostri servizi complementari per una protezione completa.",
    BACK_BUTTON: "Torna alla Home",
  },

  SECTIONS: {
    FEATURES_TITLE: "Cosa Include il Servizio:",
    BENEFITS_TITLE: "Vantaggi Principali:",
    DETAILS_TITLE: "Dettagli Tecnici",
  },

  BUTTONS: {
    PRIMARY: "Preventivo Gratuito",
    SECONDARY: "Chiama: 123 456 7890",
  },

  FORM: {
    TITLE_PREFIX: "Richiedi Preventivo",
    SUBTITLE:
      "Sopralluogo gratuito e preventivo personalizzato entro 24 ore",
    FALLBACK_TITLE: "Servizi Specializzati",
  },

  GUARANTEES: {
    TITLE: "Garanzie del Servizio",
    LIST: [
      "Sopralluogo gratuito e senza impegno",
      "Preventivo dettagliato entro 24h",
      "Assistenza post-intervento",
    ],
  },

  CTA_SECTION: {
    TITLE: "Pronto per il Tuo Servizio Specializzato?",
    DESCRIPTION:
      "Ogni problema richiede la soluzione giusta. Contattaci per scoprire quale dei nostri servizi specializzati può risolvere definitivamente la tua situazione.",
    PRIMARY_BUTTON: "Richiedi Sopralluogo Gratuito",
    FORM_TITLE: "Richiedi Preventivo Servizi Specializzati",
    FORM_SUBTITLE:
      "Sopralluogo gratuito e preventivo personalizzato entro 24 ore",
    DEFAULT_SERVICE: "pest-management",
  },

  SERVICES: [
    {
      id: "pest-management",
      title: "Pest Management",
      subtitle: "Approccio Sostenibile e Professionale",
      description:
        "Un sistema completo di gestione integrata degli infestanti che combina metodi preventivi, biologici e chimici per garantire un controllo efficace e duraturo nel rispetto dell'ambiente.",
      icon: Shield,
      image:
        "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&h=500&fit=crop",
      features: [
        "Monitoraggio costante dell'ambiente",
        "Prevenzione primaria degli infestanti",
        "Interventi mirati e sostenibili",
        "Controllo biologico naturale",
        "Riduzione uso pesticidi",
        "Piani personalizzati HACCP",
      ],
      benefits: [
        "Riduce l'impatto ambientale",
        "Maggiore efficacia a lungo termine",
        "Conformità alle normative",
        "Risparmio economico nel tempo",
      ],
      price: "A partire da €150",
      detailedInfo:
        "Il Pest Management Integrato (IPM) rappresenta l'evoluzione moderna del controllo degli infestanti. Attraverso un approccio scientifico, identifichiamo le cause delle infestazioni e implementiamo strategie preventive durature.",
      defaultService: "pest-management",
    },
    {
      id: "sanificazione",
      title: "Sanificazione Ambientale",
      subtitle: "Disinfezione Professionale Certificata",
      description:
        "Servizi completi di sanificazione e disinfezione per eliminare virus, batteri e agenti patogeni, garantendo ambienti sicuri e salubri con protocolli certificati.",
      icon: Droplets,
      image: sanificazioneImage.src,
      features: [
        "Nebulizzazione con ozono",
        "Disinfezione UV-C professionale",
        "Sanificazione aree critiche",
        "Protocolli certificati",
        "Prodotti presidio medico",
        "Certificazione di avvenuto trattamento",
      ],
      benefits: [
        "Elimina virus e batteri",
        "Ambiente sicuro e salubre",
        "Conformità sanitaria",
        "Tranquillità per clienti e dipendenti",
      ],
      price: "A partire da €200",
      detailedInfo:
        "I nostri protocolli di sanificazione seguono le linee guida del Ministero della Salute e dell'ISS. Utilizziamo tecnologie avanzate e prodotti certificati per garantire la massima efficacia.",
      defaultService: "sanificazione",
    },
    {
      id: "diserbo",
      title: "Diserbo Professionale",
      subtitle: "Controllo Erbe Infestanti e Malerbe",
      description:
        "Interventi specializzati per l'eliminazione selettiva di erbe infestanti, malerbe e vegetazione indesiderata con tecniche eco-compatibili e prodotti specifici.",
      icon: Leaf,
      image: diserboImage.src,
      features: [
        "Diserbo selettivo mirato",
        "Controllo malerbe perenni",
        "Trattamenti pre-emergenza",
        "Diserbo meccanico ecologico",
        "Prodotti biodegradabili",
        "Monitoraggio stagionale",
      ],
      benefits: [
        "Preserva le piante desiderate",
        "Risultati duraturi",
        "Rispetto dell'ecosistema",
        "Riduzione manutenzione",
      ],
      price: "A partire da €100",
      detailedInfo:
        "Il nostro approccio al diserbo privilegia metodi selettivi che eliminano solo le erbe infestanti, preservando la vegetazione desiderata e l'equilibrio naturale dell'ambiente.",
      defaultService: "diserbo",
    },
    {
      id: "allontanamento-volatili",
      title: "Allontanamento Volatili",
      subtitle: "Sistemi Avanzati Anti-Piccioni",
      description:
        "Soluzioni innovative e definitive per l'allontanamento di piccioni, gabbiani e altri volatili da edifici, monumenti e strutture urbane senza recare danno agli animali.",
      icon: Bird,
      image: volatiliImage.src,
      features: [
        "Dissuasori fisici discreti",
        "Reti anti-piccione trasparenti",
        "Sistemi sonori ad ultrasuoni",
        "Gel repellenti atossici",
        "Pulizia e bonifica guano",
        "Sistemi elettrostatici",
      ],
      benefits: [
        "Soluzione definitiva e umana",
        "Preserva l'estetica edifici",
        "Elimina rischi sanitari",
        "Lunga durata nel tempo",
      ],
      price: "A partire da €180",
      detailedInfo:
        "Utilizziamo solo sistemi cruelty-free che allontanano i volatili senza causare loro alcun danno, nel rispetto delle normative sul benessere animale.",
      defaultService: "volatili",
    },
  ],

  PRICING: {
    PEST_MANAGEMENT: "A partire da €150",
    SANIFICAZIONE: "A partire da €200",
    DISERBO: "A partire da €100",
    ALLONTANAMENTO_VOLATILI: "A partire da €180",
  },

  TECHNICAL_INFO: {
    PEST_MANAGEMENT:
      "Il Pest Management Integrato (IPM) rappresenta l'evoluzione moderna del controllo degli infestanti. Attraverso un approccio scientifico, identifichiamo le cause delle infestazioni e implementiamo strategie preventive durature.",
    SANIFICAZIONE:
      "I nostri protocolli di sanificazione seguono le linee guida del Ministero della Salute e dell'ISS. Utilizziamo tecnologie avanzate e prodotti certificati per garantire la massima efficacia.",
    DISERBO:
      "Il nostro approccio al diserbo privilegia metodi selettivi che eliminano solo le erbe infestanti, preservando la vegetazione desiderata e l'equilibrio naturale dell'ambiente.",
    ALLONTANAMENTO_VOLATILI:
      "Utilizziamo solo sistemi cruelty-free che allontanano i volatili senza causare loro alcun danno, nel rispetto delle normative sul benessere animale.",
  },

  SERVICE_CATEGORIES: {
    PEST_MANAGEMENT: "pest-management",
    SANIFICAZIONE: "sanificazione",
    DISERBO: "diserbo",
    ALLONTANAMENTO_VOLATILI: "allontanamento-volatili",
  },

  CONTACT_INFO: {
    PHONE: "123 456 7890",
    EMERGENCY_RESPONSE: "Risposta entro 24 ore",
    FREE_INSPECTION: "Sopralluogo gratuito e senza impegno",
  },
} as const;